exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".applied-filters[data-v-3bf159b1] {\n  padding: 10px 30px;\n}\n.applied-filters .el-tag[data-v-3bf159b1] {\n  margin: 3px;\n}", ""]);

// exports
